export default __webpack_public_path__ + "static/cemetery-fbfe978928b547c1c7ed1a3d022fa7c7.svg";